module.exports = __webpack_public_path__ + "img/folders.6f30cc76.svg";